import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAutoFocus from 'src/hooks/useAutoFocus';
import Button from '../../components/design-system/Button';
import Dialog from '../../components/design-system/Dialog';

interface UnsavedSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onAddToCart: () => void | Promise<void>;
  selectedItemsCount: number;
}

const UnsavedSelectionDialog = ({
  open,
  onClose,
  onConfirm,
  onAddToCart,
  selectedItemsCount,
}: UnsavedSelectionDialogProps) => {
  const { t } = useTranslation();
  const confirmButtonRef = useAutoFocus(open, [open]);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const getMessage = (): string =>
    'Changing the filter will clear the [X] Item(s) you selected. Add them to your cart now?';

  const handleAddToCart = async () => {
    setIsAddingToCart(true);
    try {
      await onAddToCart();
    } catch (error) {
      console.error(error);
    } finally {
      setIsAddingToCart(false);
    }
  };

  const message = getMessage().replace('[X]', selectedItemsCount.toString());

  return (
    <Dialog
      width="650px"
      open={open}
      onClose={onClose}
      title={t('Unsaved Selections')}
      closeIcon={true}
      id="modal"
    >
      <div className="text-black bg-white py-4 pl-4 pr-6">{message}</div>
      <DialogActionsBar>
        <div className="flex justify-end gap-3 py-3">
          <Button color="success" onClick={handleAddToCart} loading={isAddingToCart}>
            {t('Add {{count}} Item(s) to Cart', { count: selectedItemsCount })}
          </Button>
          <Button color="info" ref={confirmButtonRef} onClick={onConfirm} disabled={isAddingToCart}>
            {t('Clear Selections')}
          </Button>
          <Button color="info" onClick={onClose} disabled={isAddingToCart}>
            {t('Cancel')}
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default UnsavedSelectionDialog;
